import React from "react";
import type { FC } from "react";
import styles from "./TextAreaField.module.css";

type TextAreaFieldProps = {
  label?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  errorMessage?: string;
  className?: string;
  style?: React.CSSProperties;
  rows?:number
  span?:boolean
  customClass?:string
  showLimit?:boolean
  maxLimit?:number
  counterClass?:string
  counterContainerClass?:string
  errorClass?:string
};

const TextAreaField: FC<TextAreaFieldProps> = ({
  label,
  value,
  onChange,
  placeholder,
  disabled,
  errorMessage,
  className,
  style,
  rows=2,
  span,
  customClass,
  showLimit,
  maxLimit ,
  counterClass,
  counterContainerClass,
  errorClass
}) => {

  const isLimitExceeded = maxLimit !== undefined && (value?.length || 0) >= maxLimit;

  return (
    
    
    <div className={`${styles.textarea_wrapper} ${className || ""}`} style={style}>
      {label && <label className={styles.textarea_label}>{label}</label>}
      <textarea
        className={`${styles.textarea_box} ${customClass || ""}`} 
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        
      />
      <div className={`${styles.bottom_container}${counterContainerClass || ""}`}  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',flexDirection:'row-reverse' }}>
      {showLimit && maxLimit !== undefined && (
        <p
  
          className={`${styles.char_counter} ${counterClass || ""}`} 
          style={{
            color: isLimitExceeded ? "#ff0000" : "#6B7280",
          }}
        >
        {`${value?.length || 0} / ${maxLimit} Characters`}
        </p>
      )}

    
       {isLimitExceeded && (
          <p  className={`${styles.textarea_error} ${errorClass}`}>
            Max limit reached
          </p>
        )}

        {/* Custom error message */}
        {errorMessage && !isLimitExceeded && <p className={`${styles.textarea_error} ${errorClass}`}>{errorMessage}</p>}
      </div>
      
    </div>

  );
};

export default TextAreaField;
